// extracted by mini-css-extract-plugin
module.exports = {"step":"Steps_step__V6QbJ","title":"Steps_title__Oh8Vy","steps":"Steps_steps__uf1hK","content":"Steps_content__UgyRo","ctas":"Steps_ctas__MUIAS"};